module.exports = __webpack_public_path__ + "b228b0a368a373a70c7575fe058f6ecc.svg";